import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { label: '首页', href: '/' },
    { label: '娱乐八卦', href: '/category/entertainment' },
    { label: '社会热点', href: '/category/social' },
    { label: '明星黑料', href: '/category/celebrity' },
    { label: '网红资讯', href: '/category/internet' },
    { label: '丑闻曝光', href: '/category/scandal' },
    { label: '关于我们', href: '/about' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
      role="navigation"
      aria-label="主导航"
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-900 font-bold text-xl md:text-2xl whitespace-nowrap"
            aria-label="91吃瓜网首页"
          >
            <span
              className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg md:text-xl"
            >
              <i className="ri-water-flash-line" />
            </span>
            <span>91吃瓜网</span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                  location.pathname === link.href
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Desktop Search */}
          <div className="hidden lg:flex items-center gap-3">
            <div className="relative">
              <input
                type="search"
                placeholder="搜索爆料..."
                className="w-48 xl:w-56 bg-background-100 border border-background-200 rounded-full px-4 py-2 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-transparent"
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 hover:text-primary-500 w-4 h-4 flex items-center justify-center"
                aria-label="搜索"
              >
                <i className="ri-search-line" />
              </button>
            </div>
            <Link
              to="/category/exclusive"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
              aria-label="独家爆料"
            >
              <i className="ri-vip-crown-line" />
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            type="button"
            className="lg:hidden w-10 h-10 flex items-center justify-center text-foreground-800"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label={isMobileMenuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={isMobileMenuOpen}
          >
            <i className={isMobileMenuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`block px-3 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.href
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-3">
              <div className="relative">
                <input
                  type="search"
                  placeholder="搜索爆料..."
                  className="w-full bg-background-100 border border-background-200 rounded-full px-4 py-2.5 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300"
                />
                <button
                  type="button"
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 w-4 h-4 flex items-center justify-center"
                  aria-label="搜索"
                >
                  <i className="ri-search-line" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}